module.exports = __webpack_public_path__ + "img/image5.7117e90d.png";